import { useQuery } from '@tanstack/react-query'
import notificationService from '../../service'
import { notificationQueryKeys } from '../keys/notification.query-keys'

export const useNotificationTotalCount = () =>
  useQuery({
    queryKey: notificationQueryKeys.totalCount(),
    queryFn: notificationService.getTotalCount,
    select: (res) => res.object ?? 0,
  })
